// CSS import (webpack will bundle this)
import './styles/style.css';

// Components
import './scripts/components/index.js';

// Initialize app
import home from './scripts/view/home.js';

document.addEventListener('DOMContentLoaded', () => {
  home();
});
